import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import api      from "../api";
import { track } from "../utils/analytics";      

import CoupleImage   from "../assets/couples-account-image.jpg";
import BusinessImage from "../assets/business-account-image.jpg";

import "../styles/ChooseAccountPage.css";

export default function ChooseAccountPage() {
  const { user_id } = useParams();        // comes from /choose_account/:user_id
  const navigate    = useNavigate();

  /* ───────── analytics: page view ───────── */
  useEffect(() => {
    track("page_view", {
      page_location: window.location.href,
      page_title   : "Choose Account Type",
    });
  }, []);

  /* ───────── helper wrappers ───────── */

  const pick = async (type) => {
    // click capture ASAP
    track("account_type_select", { selected_type: type, step: "click" });

    try {
      localStorage.setItem("accountType", type);

      // 1) Save account type
      await api.post(
        "/set_user_type/",
        {},
        { params: { user_id, user_type: type }, withCredentials: true }
      );

      // 2) Trigger email verification
      await api.get("/email_verification/", {
        params: { user_id },
        withCredentials: true,
      });

      // analytics success
      track("account_type_set_success", { selected_type: type });
      window.gtag?.("set", "user_properties", { account_type: type });

      // 3) Go to verify-code screen
      navigate(`/user_verification/${user_id}`);
    } catch (err) {
      console.error("Choose-account error:", err);
      track("account_type_set_error", {
        selected_type: type,
        message      : err.message || "api_error",
      });
    }
  };

  /* ───────── render ───────── */
  return (
    <div className="choose-body">
      <div className="logo">
        <a
          href="/"
          onClick={() =>
            track("navigation_click", {
              location   : "choose_account",
              nav_item   : "Logo",
              destination: "/",
            })
          }
        >
          BestDay2Marry
        </a>
      </div>

      <div className="choose-container">
        <h1>Choose Your Account Type</h1>
        <p className="choose-blurb">
          Select the plan that best fits your needs.
        </p>

        <div className="cards-row">
          {/* Couple card */}
          <div className="account-card" onClick={() => pick("couple")}>
            <div className="card-left">
              <h2>Couple</h2>
              <p>Shared dashboards and guest matching for two.</p>
            </div>
            <div className="card-right">
              <img src={CoupleImage} alt="Couple" />
            </div>
          </div>

          <div className="card-or">or</div>

          {/* Business card */}
          <div className="account-card" onClick={() => pick("business")}>
            <div className="card-left">
              <h2>Business</h2>
              <p>Advanced analytics and team access for venues.</p>
            </div>
            <div className="card-right">
              <img src={BusinessImage} alt="Business" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}